<template>
    <div>
    <div class="Header">
        <div class="inner textalign_left display_flex  justify-content_flex-justify">
            <div  style="height:100%;position: absolute;right: 0;" class="display_flex flex-direction_column justify-content_flex-justify textalign_right">
                
                <div class="textalign_right otherlink ">
                    <a href="javascript:;" class="link-item" @click="gorouter('/about?position=technology')">{{$t('common.header.fishqc')}}</a>
                    <a href="https://vitargent.fishqc.com/" class="link-item" target="_blank">{{$t('common.header.vartagent')}}</a>
                    <div class="inline-block langcover">
                        <span class="link-item">{{$t('common.header.lang')}}</span>
                        <el-dropdown @command.native="chooselang()">
                          <span class="el-dropdown-link link-item-lang">
                            {{lang[currentlang]}}<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item,index) in langdata"  :key="index"  @click.native="chooselang(item)">{{item.lang}}</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        
                    </div>
                    
                </div>
                
                    
                <div class="inline-block" style="margin-bottom:20px;">
                    <div class="nickname vertical-middle" v-if="isLogin">
                        <span class="name">{{personinfo.nickname}}</span>
                        <div class="memberfix">
                            <ol>
                                <li @click="gorouter('/member')">{{$t('common.header.member')}}</li>
                                <li @click="gorouter('/changepassword')">{{$t('common.header.changepassword')}}</li>
                                <li @click="loginout()">{{$t('common.header.logout')}}</li>
                            </ol>
                        </div>
                    </div>
                    <div @click="headfunc" class="headImg vertical-middle cursor_p" :style="{backgroundImage:'url('+ personinfo.image +')'}"></div>
                    <!-- <img :src="personinfo.image" height="40" width="40" class="vertical-middle cursor_p" style="margin-left:10px;border-radius:50%" @click="headfunc"> -->
                </div>
                    
                
            </div>
            <div class="display_flex align-items_center">
                <div class="Logoicon" @click="gorouter('/')"></div>
                <!-- <img :src="headLogo"   :class="['logo','cursor_p','width_200',{'width_180':currenttype =='eng'}]"  title="好东西，就要小鱼亲测" @click="gorouter('/')"> -->
                <div   class="inline-block vertical-middle hometab" v-if="onRoutes !== 'modifyInfo' ">
                    <span  :class="[currentmenu.title == item.title ? 'active':'','tabindex']" v-for="item in menu[currentlang]" @click="handleClick(item)">{{item.title}}</span>
                </div>
               
               <!--  <el-tabs v-model="activeName" @tab-click="handleClick1" class="inline-block vertical-middle hometab">
                    <el-tab-pane label="首页" name="first"></el-tab-pane>
                    <el-tab-pane label="榜单报告" name="second"></el-tab-pane>
                    
                    <el-tab-pane label="小鱼优品" name="fourth"></el-tab-pane>
                    <el-tab-pane label="放心试用" name="fiveth"></el-tab-pane>
                    <el-tab-pane label="精选文章" name="sixth"></el-tab-pane>
                    <el-tab-pane label="关于小鱼" name="seventh"></el-tab-pane>
                    <el-tab-pane label="已购" name="third"></el-tab-pane>
                </el-tabs> -->
            </div>
            
        </div>
        
    </div>
    <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.Logoicon{
    width: 186px;
    height: 52.7px;
    background-image:url('https://p1.fishqc.net/FrSb5jkNK6Wvm95F3da387mcTen4');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 32px;
    cursor: pointer;
}
.Header {
    height: 99px;
    border: 1px solid #E9E9EB;
	position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    z-index:20;
    background-color: #fff;
    .hometab{
        margin:12px 0 0;
        // width: 608px;
        .tabindex{
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 22px;
            cursor: pointer;
            position: relative;
            margin-right: 40px;
            &:last-child{
                margin-right: 0;
            }
            &.active{
                color:$maincolor;
                &:after{
                        content: "";
                        position: absolute;
                        bottom: -16px;
                        left: 50%;
                        width: 40px;
                        height: 8px;
                        background-image: url('../assets/images/nav.png');
                        background-size: 40px 8px;
                        background-position: center center;
                        transform: translate(-50%, 0);
                }
            }
            &:hover{
                color: $maincolor;
            }
        }
    }
    .otherlink {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 12px;
        padding: 10px 0 0;

        .link-item {
            color: #A8A8AD;
            vertical-align: middle;
			&:nth-of-type(2){
				margin: 0 24px;
			}
            // &:last-child {
            //     margin: 0 24px;

            // }
        }

        .link-item-lang{
            width: 32px;
            height: 16px;
            line-height:16px;
            background: #A8A8AD;
            border-radius: 2px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            display: inline-block;
            text-align: center;
            margin-left: 10px;
        }
    }
}

.logo {
    margin: 0px 30px 0 0;
    &.width_180{
        width: 180px;
    }
    &.width_200{
        width: 200px;
    }
}

.nickname {

    margin-left: 64px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    .name {
        max-width: 84px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: 400;
        display: inline-block;
        vertical-align: middle;
		font-family: PingFangSC-Regular, PingFang SC;
		color: #A8A8AD;
		line-height: 17px;
    }

    &:hover {
        .memberfix {
            display: block
        }
    }

    .memberfix {
        display: none;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        width: 90px;
        font-size: 14px;
        color: #000;
        background: #fff;
        z-index: 2;
        padding: 10px 0px;
        line-height: 30px;
        text-align: center;
        top: 130%;
        border-radius: 4px;
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

        &:before {
            content: '';
            position: absolute;
            left: 50%;
            top: -6px;
            transform: translate(-50%, 0);
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 10px solid #fff;
        }

        &:hover {
            color: #060C41;

        }

        ol {
            li:hover {
                color: #6EDCC7;
            }
        }
    }
}
</style>
<style type="text/css" lang="scss">
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #ecf5ff;
        color: #60DEB4 !important;
    }
.Header {
    .el-tabs__item {
        color: #60DEB4;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #51515C;
        padding: 0 19px;
        height: 58px;
        line-height: 58px;
    }

    .el-tabs__item.is-active {
        color: #60DEB4;
    }

    .el-tabs__active-bar {
        height: 8px;
        background-color: #fff;
        background-image: url(../assets/images/nav.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        min-width: 40px !important;

    }

    .el-tabs__nav-wrap::after {
        background-color: #fff;
    }

    .el-tabs__header {
        margin: 0;
    }

    .el-dropdown{
        vertical-align: middle;  
        width: 32px;
        height: 16px;
        cursor: pointer;
    }

    

}

.headImg{
    width:40px;
    height: 40px;
    margin-left:10px;
    border-radius:50%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('http://p1.fishqc.net/Fi-1EPZU5g-a1c_iUa46e2y3LzpZ');
        display: inline-block;
}
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'
import {logoutApi} from '@/api/api.js'
import { getCookie } from '@/utils/cookieUtil'
import { personinfoApi} from '@/api/api.js'
import Modal from '@/components/Modal.vue'
export default {
    name: 'Header',
    components: {
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            headLogo:this.$t('common.headLogo'),
            menu: {
                'chs':[
                    {
                        title: this.$t('common.home'),     
                        path: '/',
                       
                    },
                    {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                        
                    },
                    {
                        title: this.$t('index.product'),
                        path: '/product',
                        
                    },
                    // {
                    //     title: this.$t('common.header_try'),
                    //     path: '/try',
                        
                    // },
                    {
                        title: this.$t('index.article'),
                        path: '/article',
                        
                    },
                    {
                        title: this.$t('personal.aboutFQC'),
                        path: '/about',
                        
                    },
                    {
                        title: this.$t('rankindex.bought'),
                        path: '/bought',
                        
                    }
                ],
                'cht':[
                    {
                        title: this.$t('common.home'),     
                        path: '/',
                       
                    },
                    {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                        
                    },
                    {
                        title: this.$t('index.product'),
                        path: '/product',
                        
                    },
                    // {
                    //     title: this.$t('common.header_try'),
                    //     path: '/try',
                        
                    // },
                    {
                        title: this.$t('index.article'),
                        path: '/article',
                        
                    },
                    {
                        title: this.$t('personal.aboutFQC'),
                        path: '/about',
                        
                    },
                    {
                        title: this.$t('rankindex.bought'),
                        path: '/bought',
                        
                    }
                ],
                'eng':[
                    {
                        title: this.$t('common.home'),     
                        path: '/',
                       
                    },
                    {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                        
                    },
                    {
                        title: this.$t('index.product'),
                        path: '/product',
                        
                    },
                    // {
                    //     title: this.$t('common.header_try'),
                    //     path: '/try',
                        
                    // },
                    // {
                    //     title: this.$t('index.article'),
                    //     path: '/article',
                        
                    // },
                    {
                        title: this.$t('personal.aboutFQC'),
                        path: '/about',
                        
                    },
                    {
                        title: this.$t('rankindex.bought'),
                        path: '/bought',
                        
                    }
                ]
            },
            
            currentmenu:{
                title:this.$t('common.home')
            },
            tabindex:'tabindex',
            activeName: 'first',
            nickname: '用户名称',
            personinfo:{
                nickname:this.$t('common.nickname'),
                image:'http://p1.fishqc.net/Fi-1EPZU5g-a1c_iUa46e2y3LzpZ'

            },
            isLogin:false,
            langdata:[
                {
                    type:'chs',
                    lang:'简体'
                },
                {
                    type:'cht',
                    lang:'繁體'
                },
                {
                    type:'eng',
                    lang:'EN'
                }
            ],
            currentlang:'',
            currenttype:'',
            lang:{
                'chs':'简体',
                'cht':'繁體',
                'eng':'EN',
            }

        }
    },

    watch:{
        '$route.name'(val){
            console.log('路径',val)
            this.geturlactive()
        }
        // $route:{
        //   handler(val,oldVal){
        //     this.activIndex=this.funList.findIndex((item) =>{
        //         return ~(val.fullPath).indexOf(item.type)
        //     })
        //     console.log(this.activIndex)
            
        //   },
        //   deep:true
        // }
    },
    computed: {

    },
    methods: {
    	handleClick(item) {
            console.log(item)
            this.currentmenu = item
            if(item.path == '/try'){
                // 触发放心试弹窗
                this.$refs.modaltoast.show({
                    type:'try',
                    source:'header',
                    try_url:'https://try.fishqc.com/'
                });
                
                return
            }
            if(item.path !== '/try'){
                // 触发放心试弹窗
                this.$refs.modaltoast.hidemodal();
                
                
            }
            this.$router.push({
                path:item.path
            })
        	// console.log(tab.label);

            // switch (tab.label){
            //     case '首页':
            //     this.gorouter('/')
            //     break;
            //     case '榜单报告':
            //     this.gorouter('reportlist')
            //     break;
            //     case '小鱼优品':
            //     this.gorouter('product')
            //     break;
            //     case '精选文章':
            //     this.gorouter('/article')
            //     break;
            //     case '已购':
            //     this.gorouter('bought')
            //     break;
            //     case '关于小鱼':
            //     this.gorouter('about')
            //     break;
            // }
        	
      	},
        handleClick1(tab) {
            console.log(tab)
            // this.currentmenu = item
            // if(item.path == '/try'){
            //     // 触发放心试弹窗
            //     this.$refs.modaltoast.show({
            //         type:'try',
            //     });
                
            //     return
            // }
            // this.$router.push({
            //     path:item.path
            // })
            console.log(tab.label);

            switch (tab.label){
                case this.$t('common.home'):
                this.gorouter('/')
                break;
                case this.$t('index.rank'):
                this.gorouter('reportlist')
                break;
                case this.$t('index.product'):
                this.gorouter('product')
                break;
                case '精选文章':
                this.gorouter('/article')
                break;
                case '已购':
                this.gorouter('bought')
                break;
                case '关于小鱼':
                this.gorouter('about')
                break;
            }
            
        },
        getmaterial(){

        },
        loginout(){
            logoutApi({}).then(res => {
                if(res.code == 200){
                    this.gorouter('/')
                    this.isLogin = false
                    this.personinfo = {
                        nickname:'',
                        image:'http://p1.fishqc.net/Fi-1EPZU5g-a1c_iUa46e2y3LzpZ'
                    }
                    this.$forceUpdate()
                }else{
                    this.toast(res.message)
                    
                }
            })
        },
        headfunc(){
            if(getCookie('fqcU')){
                this.gorouter('/member')
            }else{
                var  returnURL = window.location.href
                this.gorouter('/login?region=0'+'&returnURL='+returnURL)
            }
            
            
        },
        personinfofun(){
            personinfoApi({}).then(res => {

                if (res.code == 200) {
                    console.log(res.data)
                    this.personinfo = res.data
                }else if(res.code == 401){

                }else {
                    // this.toast(res.message)
                    
                }
            })

        },
        chooselang(item){
            console.log(item)
            //this.currentlang = item.lang
            //this.currenttype = item.type
            //this.$i18n.locale = item.type
            window.localStorage.setItem("LOCALE", item.type);

            this.$router.go(0);
        },
        geturlactive(){
            switch(this.$route.name){
                case 'index':
                this.currentmenu = 
                    {
                        title: this.$t('common.home'),     
                        path: '/',
                       
                    }
            
                break;
                case 'reportlist':
                    this.currentmenu = {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                        
                    }
                break;
                case 'product':
                    this.currentmenu = {
                        
                        title: this.$t('index.product'),
                        path: '/product',
                    }
                break;
                case 'article':
                    this.currentmenu = {
                        
                        title: this.$t('index.article'),
                        path: '/article',
                    }
                break;
                case 'bought':
                    this.currentmenu = {
                        title: this.$t('rankindex.bought'),
                        path: '/bought',
                    
                    }
                break;
                case 'shoppingCart':
                    this.currentmenu = {
                    
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    }
                break;
                case 'member':
                    this.currentmenu = {
                    
                        title: this.$t('common.home'),     
                        path: '/',
                    }
                break;
                case 'pay':
                    this.currentmenu = {
                    
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    }
                break;
                case 'orderdetail':
                    this.currentmenu = {
                    
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    }
                break;
                case 'payway':
                    this.currentmenu = {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    
                    }
                break;
                case 'articledetail':
                    this.currentmenu = {
                    
                        title: this.$t('index.article'),
                        path: '/article',
                    }
                break;
                case 'about':
                    this.currentmenu = {
                        title: this.$t('personal.aboutFQC'),
                        path: '/about',
                    
                    }
                break;
                case 'rankdetail':
                    this.currentmenu = {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    
                    }
                break;
                case 'reportdetail':
                    this.currentmenu = {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    
                    }
                break;
                case 'productdetail':
                    this.currentmenu = {
                        title: this.$t('index.product'),
                        path: '/product',
                    
                    }
                break;
                case 'modifyInfo':
                    this.currentmenu = {
                        title: this.$t('common.home'),     
                        path: '/',
                    
                    }
                break;
                case 'myorder':
                    this.currentmenu = {
                        title: this.$t('index.rank'),
                        path: '/reportlist',
                    
                    }
                break;
                case 'myCollection':
                    this.currentmenu = {
                    
                        title: this.$t('common.home'),     
                        path: '/',
                    }
                break;

            }
            
        }

    },
    mounted() {
        console.log(getCookie('fqcTK'))
        console.log( getCookie('fqcU'))
        console.log(getCookie('fqcTK') && getCookie('fqcU'))
        //
        var current = window.localStorage.getItem("LOCALE");
        this.currentlang = window.localStorage.getItem("LOCALE") ||'chs'
        if(current == 'eng'){
            this.currenttype = window.localStorage.getItem("LOCALE")
        }
        //this.$i18n.locale = window.localStorage.getItem('LOCALE');
        // this.langdata.forEach((val)=>{
        //     if(val.type == current){
        //         this.currentlang = val.lang
        //     }
        // })
        //
        if(getCookie('fqcU')){
            console.log('登录了')
            this.isLogin =true
            
        }else{
            console.log('未登录')
            this.isLogin = false
            this.personinfo = {
                nickname:'',
                image:'http://p1.fishqc.net/Fi-1EPZU5g-a1c_iUa46e2y3LzpZ'
            }
        }

        this.personinfofun()
        
        this.geturlactive()
    }
}
</script>